import Router from 'vue-router';
import Home from '@/components/Home.vue';
import Empty from '@/components/Empty.vue';
import Godfather from '@/components/Godfather.vue';
import Vue from 'vue';
import Meta from 'vue-meta';
import localeService from '@/services/localeService';
import _ from 'lodash';
import oLocalStorage from '@/services/objectLocalStorage';
import keys from '@/store/keys';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      name: 'Home',
      alias: ['/ar', '/cl', '/co', '/es', '/mx', '/uy', '/br', '/ca']
    },
    {
      path: '/es/ayuda-a-tu-amigo/iniciar-registro',
      component: Godfather,
      name: 'Godfather',
      alias: [
        '/cl/ayuda-a-tu-amigo/iniciar-registro',
        '/ca/ajuda-a-teu-amic/iniciar-registre',
        '/ar/ayuda-a-tu-amigo/iniciar-registro',
        '/cl/ayuda-a-tu-amigo/iniciar-registro',
        '/co/ayuda-a-tu-amigo/iniciar-registro',
        '/mx/ayuda-a-tu-amigo/iniciar-registro',
        '/uy/ayuda-a-tu-amigo/iniciar-registro',
        '/br/ajude-seu-amigo/iniciar-registro'
      ]
    },
    {
      path: '/spain*',
      redirect: to => {
        return `/es/ayuda-a-tu-amigo/iniciar-registro`;
      }
    },
    {
      path: '/chile*',
      redirect: to => {
        return `/cl/ayuda-a-tu-amigo/iniciar-registro`;
      }
    },
    {
      path: '/purchaseCallback*',
      component: Empty,
      name: 'Empty'
    },

    {
      path: '*',
      name: 'All',
      component: Home
    }
  ]
});

router.beforeEach((to, from, next) => {
  let citySelected = oLocalStorage.get(keys.citySelected);
  if (citySelected !== null) {
    if (typeof to.query.r === 'undefined' || to.query.r === 0) {
      if (to.name !== 'Godfather') {
        window.location = citySelected.action;
        return;
      }
    }
    oLocalStorage.remove(keys.citySelected);
  }

  let country = '';
  let start = to.path.indexOf('/');

  country = to.path.substr(start + 1, 2).toUpperCase();

  if (!_.isEmpty(country)) {
    localeService.changeCountryLanguage(country);
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js